import { docodeHexResponse } from '../../../_common/common.utils';
import OpeningBalanceActionTypes from './opening-balance.types';

const INITIAL_STATE = {
	// GET OPENING BALANCE DETAILS
	openingbalanceDetailsResponse: null,
	openingbalanceDetailsArr: [],
	// UPDATE OPENING BALANCE DETAILS
	openingbaLUpdateDetailsResponse: null,
};
const OpeningBalanceReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** ADD GST TYPE DETAILS START *********************** */
		case OpeningBalanceActionTypes.GET_OPENING_BALANCE_DETAILS_SUCCESS:
			return {
				...state,
				openingbalanceDetailsResponse: action.payload,
				openingbalanceDetailsArr: docodeHexResponse(
					action.payload,
					'OpeningBalanceListKey',
				),
			};

		case OpeningBalanceActionTypes.GET_OPENING_BALANCE_DETAILS_FAILURE:
			return {
				...state,
				openingbalanceDetailsResponse: action.payload,
				openingbalanceDetailsArr: [],
			};

		case OpeningBalanceActionTypes.GET_OPENING_BALANCE_DETAILS_RESPONSE_CHANGED:
			return { ...state, openingbalanceDetailsResponse: null };
		/** ***************** ADD GST TYPE DETAILS END *********************** */

		/** ***************** UPDATE GST TYPE DETAILS START *********************** */
		case OpeningBalanceActionTypes.UPDATE_OPENING_BALANCE_DETAILS_SUCCESS:
			return { ...state, openingbaLUpdateDetailsResponse: action.payload };

		case OpeningBalanceActionTypes.UPDATE_OPENING_BALANCE_DETAILS_FAILURE:
			return { ...state, openingbaLUpdateDetailsResponse: action.payload };

		case OpeningBalanceActionTypes.UPDATE_OPENING_BALANCE_DETAILS_RESPONSE_CHANGED:
			return { ...state, openingbaLUpdateDetailsResponse: null };
		/** ***************** UPDATE GST TYPE DETAILS END *********************** */

		default:
			return state;
	}
};
export default OpeningBalanceReducer;
